import {connect} from "react-redux";
import SearchUniverseBusiness from "./Search";
import {bindActionCreators} from "redux";
import {dropdownData, infraProject, saveInfraProject} from "../../../../service/Account/action";
const mapStateToProps = (state) => ({
    dropdownValue:state.Dropdown.dropdownValue,
    infraProjectResponse:state.Dropdown.infraProjectResponse,
    saveBusiness:state.Dropdown.saveBusiness,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            dropdownData,
            infraProject,
            saveInfraProject
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(SearchUniverseBusiness);
